import { c as _c } from "react/compiler-runtime";
import pluralize from 'pluralize';
import { useEffect, useState } from 'react';
import { StructuredText } from 'react-datocms';
import { Heading } from 'ui';
import { shortDateMonthYear, shortDay } from 'utils/DateFormats';
import { ChipHeader } from '~/components/ChipHeader';
import type { LocationProps } from './Location.types';
const Location = t0 => {
  const $ = _c(43);
  const {
    location,
    isMinimal,
    userSpecificDescription
  } = t0;
  const {
    endDate,
    nights,
    place,
    startDate,
    title,
    type
  } = location;
  let t1;
  if ($[0] !== nights) {
    t1 = nights && `${nights} ${pluralize("Night", nights)}`;
    $[0] = nights;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const duration = t1;
  let t2;
  if ($[2] !== startDate) {
    t2 = startDate ? shortDay(startDate) : "";
    $[2] = startDate;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== endDate || $[5] !== startDate) {
    t3 = startDate !== endDate ? ` - ${shortDay(endDate)}` : "";
    $[4] = endDate;
    $[5] = startDate;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = `${t2}${t3}`;
  let t5;
  if ($[7] !== t4) {
    t5 = [t4].filter(Boolean);
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const dayTags = t5;
  let t6;
  if ($[9] !== startDate) {
    t6 = startDate ? shortDateMonthYear(startDate) : "";
    $[9] = startDate;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== endDate || $[12] !== startDate) {
    t7 = startDate !== endDate ? ` - ${shortDateMonthYear(endDate)}` : "";
    $[11] = endDate;
    $[12] = startDate;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const t8 = `${t6}${t7}`;
  let t9;
  if ($[14] !== t8) {
    t9 = [t8].filter(Boolean);
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const dateTags = t9;
  let t10;
  if ($[16] !== dateTags || $[17] !== dayTags) {
    t10 = [...dayTags, ...dateTags];
    $[16] = dateTags;
    $[17] = dayTags;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  const tags = t10;
  const [mounted, setMounted] = useState(false);
  let t11;
  let t12;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = () => setMounted(true);
    t12 = [];
    $[19] = t11;
    $[20] = t12;
  } else {
    t11 = $[19];
    t12 = $[20];
  }
  useEffect(t11, t12);
  let t13;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = ["map-pin"];
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== tags || $[23] !== type) {
    t14 = <ChipHeader type={type} tags={tags} icons={t13} />;
    $[22] = tags;
    $[23] = type;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== title) {
    t15 = <Heading as="h2" variant="h5"><span className="font-serif font-normal">{title}</span></Heading>;
    $[25] = title;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== duration || $[28] !== nights) {
    t16 = nights > 0 && <p className="typography-emphasis-2 mt-4px">{duration}</p>;
    $[27] = duration;
    $[28] = nights;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== isMinimal || $[31] !== mounted || $[32] !== place?.description || $[33] !== place?.extendedDescription || $[34] !== userSpecificDescription) {
    t17 = !isMinimal && (userSpecificDescription || place?.description) && <>{mounted ? <p className="mt-16px" dangerouslySetInnerHTML={{
        __html: userSpecificDescription || place?.description || ""
      }} /> : null}<div className="prose-a:underline"><StructuredText data={place?.extendedDescription} /></div></>;
    $[30] = isMinimal;
    $[31] = mounted;
    $[32] = place?.description;
    $[33] = place?.extendedDescription;
    $[34] = userSpecificDescription;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t15 || $[37] !== t16 || $[38] !== t17) {
    t18 = <div className="pt-16px pb-24px print:break-inside-avoid">{t15}{t16}{t17}</div>;
    $[36] = t15;
    $[37] = t16;
    $[38] = t17;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== t14 || $[41] !== t18) {
    t19 = <>{t14}{t18}</>;
    $[40] = t14;
    $[41] = t18;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  return t19;
};
export { Location };